import { Box, Button } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { Collections } from "api";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useFirebase, useFirestore } from "react-redux-firebase";
import { RootState } from "redux/model";
import { ConfirmationDialog, ConfirmationDialogState } from "ui/componentes";

const PasswordResetForm = () => {
    const firebase = useFirebase();
    const firestore = useFirestore();
    const { auth } = useSelector((state: RootState) => state.firebase);
    const { enqueueSnackbar } = useSnackbar();
    const [confirmation, setConfirmation] = useState<ConfirmationDialogState>({
        showDialog: false,
        message: "Deseja realmente alterar sua senha?",
        onOk: () => {
            if (auth.email) {
                firebase
                    .auth()
                    .sendPasswordResetEmail(auth.email, {
                        url: window.location.origin,
                    })
                    .then(() => {
                        firestore
                            .collection(Collections.USERS_PRIVATE_INFO)
                            .doc(auth.uid)
                            .update({ tempPassword: "" });
                    })
                    .then(() => {
                        enqueueSnackbar(
                            `Um email foi enviado para ${auth.email} para redefinição de senha!`,
                            { variant: "success" }
                        );
                        setConfirmation((old) => ({
                            ...old,
                            showDialog: false,
                        }));
                    })
                    .catch(console.error);
            }
        },
    });

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="300px"
        >
            <ConfirmationDialog
                title={confirmation.title}
                showDialog={confirmation.showDialog}
                message={confirmation.message}
                onCancel={() =>
                    setConfirmation((old) => ({ ...old, showDialog: false }))
                }
                onOk={confirmation.onOk}
            />
            <Button
                style={{
                    backgroundColor: green[500],
                    color: "#FFFFFF",
                    maxWidth: "500px",
                }}
                onClick={() => {
                    setConfirmation((old) => ({ ...old, showDialog: true }));
                }}
            >
                Solicitar alteração de senha
            </Button>
        </Box>
    );
};

export { PasswordResetForm };
